import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import {
    trigger,
    state,
    style,
    animate,
    transition,
} from '@angular/animations';
import { PdfLoadingService } from '@app/core/services/pdf-loading.service';

@Component({
    selector: 'app-pdf-loading-overlay',
    templateUrl: './pdf-loading-overlay.component.html',
    styleUrl: './pdf-loading-overlay.component.scss',
    standalone: false,
    animations: [
        trigger('overlayAnim', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('220ms ease-out', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ opacity: 0 })),
            ]),
        ]),
        trigger('cardAnim', [
            transition(':enter', [
                style({ opacity: 0, transform: 'scale(0.85) translateY(20px)' }),
                animate('280ms cubic-bezier(0.34, 1.56, 0.64, 1)',
                    style({ opacity: 1, transform: 'scale(1) translateY(0)' })),
            ]),
            transition(':leave', [
                animate('180ms ease-in',
                    style({ opacity: 0, transform: 'scale(0.9) translateY(10px)' })),
            ]),
        ]),
    ],
})
export class PdfLoadingOverlayComponent {
    private readonly pdfLoadingService = inject(PdfLoadingService);
    readonly label$   = this.pdfLoadingService.label$;
    readonly variant$ = this.pdfLoadingService.variant$;
}
